import { render } from "./Textarea.vue?vue&type=template&id=2ee0a393"
import script from "./Textarea.vue?vue&type=script&lang=js"
export * from "./Textarea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/Textarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ee0a393"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ee0a393', __exports__)) {
    api.reload('2ee0a393', __exports__)
  }
  
  module.hot.accept("./Textarea.vue?vue&type=template&id=2ee0a393", () => {
    api.rerender('2ee0a393', render)
  })

}


export default __exports__